import { useState, useEffect } from "react";
import { Link } from "wouter";
import { useLanguage } from "@/contexts/LanguageContext";

export default function CookieBanner() {
  const { t } = useLanguage();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("villa_cookie_consent");
    if (!consent) {
      // Show after a short delay
      const timer = setTimeout(() => setVisible(true), 1500);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem("villa_cookie_consent", "all");
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem("villa_cookie_consent", "essential");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 animate-fade-in-up">
      <div className="bg-[var(--noir)] border-t border-[var(--gold)] px-4 py-5 md:py-4">
        <div className="container">
          <div className="flex flex-col md:flex-row items-start md:items-center gap-4">
            <div className="flex-1">
              <p className="font-dm-serif text-sm text-white mb-1">{t("cookie_title")}</p>
              <p className="font-poppins text-xs text-white/60 leading-relaxed">
                {t("cookie_text")}{" "}
                <Link href="/politique-de-confidentialite" className="text-[var(--gold-light)] hover:underline">
                  {t("cookie_more")}
                </Link>
              </p>
            </div>
            <div className="flex gap-3 shrink-0">
              <button
                onClick={refuse}
                className="font-dm-serif text-xs tracking-[0.15em] uppercase text-white/60 hover:text-white transition-colors px-3 py-2 border border-white/20 hover:border-white/50"
              >
                {t("cookie_refuse")}
              </button>
              <button
                onClick={accept}
                className="btn-gold-filled text-xs py-2 px-4"
              >
                {t("cookie_accept")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
